/**
 * Warstwa API: IMPORT HASEŁ Z PLIKU EXCEL do banków haseł działów (polecenie właściciela 2026-10-03).
 *
 * Właściciel: „w sekcji /admin/password-manager dodaj mi możliwość importu pliku z hasłami — pliku excel, z przypisaniem
 * bazy haseł do konkretnego działu / modułu / działu w aplikacji, z opcją pobrania pliku wzorcowego”.
 *
 * Trasy backendu (SejfController, `api/sejf/import/*`, każda za kluczem need-to-know `SejfImportBankow`):
 *  - `GET cele` — dokąd wolno importować: `{ dzialy[{ id, nazwa, spolka, sciezka, kod, wpisow, osobyZDostepem, czlonek }],
 *    moduly[{ kod, nazwa, dzialy[{ id, nazwa, kod }], powod }], wgladCentralny, limity{ maksBajtow, maksWierszy },
 *    kolumny[{ id, naglowek, wymagana, limit, opis }], polityki[] }`;
 *  - `GET wzor` — plik wzorcowy .xlsx (blob; nazwa w Content-Disposition, `filename*=UTF-8''…`);
 *  - `POST podglad` (multipart: plik, cel, departmentId?, modulKod?, polityka) — plan importu bez zapisu;
 *  - `POST zastosuj` (ten sam multipart + skrot i skrotPlanu z podglądu) — zapis wszystko albo nic; 409
 *    `sejf_import_plik_zmieniony` = inny plik, 409 `sejf_import_plan_zmieniony` = bank zmienił się od podglądu.
 *
 * ŻADNA ODPOWIEDŹ NIE NIESIE HASŁA ANI NOTATKI — nawet ich długości. Podgląd mówi tylko „ustawione” albo „puste”.
 * Przeglądarka nie czyta pliku: obiekt File idzie na serwer dwa razy (podgląd, zapis) i znika razem z szufladą.
 *
 * Nazwy metod są długie świadomie: trafiają do wspólnego `apiService` i muszą być unikalne w całej aplikacji
 * (patrz attachApiModules).
 */
const MULTIPART = { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 };

export function attach(api) {
    return {
        /** Banki działów i moduły obsługi, do których wołający może importować, oraz limity i kolumny pliku. */
        pobierzCeleImportuHasel: () => api.get("/sejf/import/cele"),

        /** Plik wzorcowy .xlsx — generowany na serwerze przy każdym pobraniu, bez żadnych istniejących haseł. */
        pobierzWzorImportuHasel: () => api.get("/sejf/import/wzor", { responseType: "blob" }),

        /** Sprawdzenie pliku: plan importu (statusy wierszy, duplikaty, błędy), nic nie jest zapisywane. */
        podgladImportuHasel: (formData) => api.post("/sejf/import/podglad", formData, MULTIPART),

        /** Zapis planu — ten sam plik i skrót SHA-256 z podglądu; przy jakimkolwiek błędzie nie zapisuje niczego. */
        zastosujImportHasel: (formData) => api.post("/sejf/import/zastosuj", formData, MULTIPART),
    };
}
